import { BoxStaffInvitation } from "@modules/boxStaff/components/boxStaffInvitation"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { SidebarNavigatorParams } from "@modules/sidebar/sidebarTypes"
import { LocalStorageKeys } from "@modules/storage/localStorageKeys"

export const useBoxStaffInvitationSidebar = () => {
  const { sidebarNavigateTo } = useSidebar()

  const navigateToBoxStaffInvitation = (args: SidebarNavigatorParams) => {
    sidebarNavigateTo({
      content: <BoxStaffInvitation />,
      onHide: () => {
        localStorage.removeItem(LocalStorageKeys.boxStaffInvitation.boxId)
        return Promise.resolve(true)
      },
      ...args,
    })
  }

  return { navigateToBoxStaffInvitation }
}
